import React from "react";
import { ParticipantStatus } from "../../../../Shared/GeneratedTypes";
import { Participant } from "../../../../Shared/sharedTypes";
import { ApplicationData } from "../../../types";
import ParticipantSection from "./ParticipantSection"

type PropTypes = {
    participants: Participant[];
};

export default function Participants(
    {
        participants
    }: PropTypes) {

    return (
        <div style={{ width: '100%', overflowY: 'auto', paddingBottom: '4rem' }}>
            <ParticipantSection participants={participants}/>
        </div>
    );
}